import {apiRequest} from '../utils/apiHelper'
import {HTTP_CALL_TYPE, API_URL_RESOURCE} from '../utils/constants'
import Cryptr from 'cryptr'
const publicIp = require('react-public-ip')
let realIp
const GetRealIP = async () => {
    realIp = await publicIp.v4()
}
GetRealIP()
export const saveResetPassword = async inputData => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + 'clientprogram/resetpassword',
        inputData,
        {},
        HTTP_CALL_TYPE.POST
    )
    return response
}

export const getProgramConfiguration = async () => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + 'clientprogram/innerconfig',
        {},
        {route: 'onboard '}
    )
    return (
        response.hasOwnProperty('error') &&
        (Object.keys(response.error).length > 0 ? {} : response.success)
    )
}

export const getLoginProfileDetails = async () => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + 'clientprogram/userprofile',
        {},
        {route: 'onboard '}
    )
    return (
        response.hasOwnProperty('error') &&
        (Object.keys(response.error).length > 0 ? {} : response.success)
    )
}

export const getSignOut = async () => {
    if (realIp === undefined) {
        realIp = await publicIp.v4()
    }
    const options = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            //  'real-ip': realIp,
        },
        credentials: 'include',
    }
    // const requiredCredentials =
    //     process.env.REACT_APP_API_LOCAL_ENV === 'true' ? true : false
    // if (requiredCredentials) options['credentials'] = 'include'

    const response = await fetch(API_URL_RESOURCE.URL + 'token/deactivate', options)
    if (response.status === 401) {
        sessionStorage.clear()
        window.location.reload(false)
    }
    const result = await response.json()
    return result
}

export const getProgramOutreachConfiguration = async route => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + 'clientprogram/outerconfig',
        {}
    )
    return (
        response.hasOwnProperty('error') &&
        (Object.keys(response.error).length > 0 ? {} : response.success)
    )
}

export const getValidateSession = async continuetoken => {
    const token = continuetoken !== undefined ? {continuetoken} : {}
    const response = await apiRequest(
        API_URL_RESOURCE.URL + 'clientprogram/verifyrequest',
        token
    )
    return (
        response.hasOwnProperty('error') &&
        (Object.keys(response.error).length > 0 ? {} : response.success)
    )
}

export const forgotPasswordForm = async inputData => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + 'clientprogram/forgotpassword',
        inputData,
        {},
        HTTP_CALL_TYPE.POST
    )
    return response
}

export const getEncryptedVersion = input => {
    const CRYPTR_ASE_KEY = '60jIL#jEm8eIhR1F2zo!jD7s^3ZEfmY3'
    const cryptr = new Cryptr(CRYPTR_ASE_KEY)
    return cryptr.encrypt(input)
}

export const authenticationApi = async input => {
    const searchParams = Object.keys(input)
        .map(key => {
            return encodeURIComponent(key) + '=' + encodeURIComponent(input[key])
        })
        .join('&')
    if (realIp === undefined) {
        realIp = await publicIp.v4()
    }
    const options = {
        method: 'post',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            //'real-ip': realIp,
        },
        body: searchParams,
        credentials: 'include',
    }
    // const requiredCredentials =
    //     process.env.REACT_APP_API_LOCAL_ENV === 'true' ? true : false
    // if (requiredCredentials) options['credentials'] = 'include'
    const response = await fetch(
        API_URL_RESOURCE.URL + 'clientprogram/checkidpwddb',
        options
    ).then(res => {
        return res.json()
    })

    return response
}

export const registrationEmail = async inputData => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + 'clientprogram/email/resend',
        inputData,
        {},
        HTTP_CALL_TYPE.POST
    )
    return response
}

export const forgotPasswordEmail = async inputData => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + 'clientprogram/email/forgotpassword',
        inputData,
        {},
        HTTP_CALL_TYPE.POST
    )
    return response
}

export const getOuterAuthenticate = async input => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + 'clientprogram/user/verifyauth',
        input,
        {},
        HTTP_CALL_TYPE.POST
    )

    return response
}

export const getVerifyMember = async input => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + 'clientprogram/verifymember',
        input,
        {}
    )
    return response
}

export const getValidateDealSession = async deal => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + 'clientprogram/verifyrequest',
        deal
    )
    return response
}

export const getPaymentPopupStatus = async headerProp => {
    const response = await apiRequest(
        API_URL_RESOURCE.URL + 'cliententity/paymentpopupstatus',
        {},
        headerProp
    )
    return response
}
